<template>
    <v-card class="package-update-modal px-6 py-5 text-center">
        <div class="package-update-modal-icon mx-auto mt-2 mb-6">
            <v-icon color="#4CAF50" size="36">mdi-check</v-icon>
        </div>

        <h2 class="font-weight-bold mt-5 mx-auto package-update-modal-title">
            Your subscription has been updated.
        </h2>

        <p class="package-update-modal-description mt-5 mb-0">
            Closing this message starts a 10-minute grace period to save your work before the platform automatically refreshes.
        </p>

        <v-btn
            block
            variant="outlined"
            height="48"
            class="mt-6 close-btn"
            @click="emit('close');"
        >
            Close
        </v-btn>
    </v-card>
</template>
<script setup lang="ts">

const emit = defineEmits(['close']);

</script>
<style scoped>
.package-update-modal-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #E8F5E9;
    display: flex;
    align-items: center;
    justify-content: center;
}
.package-update-modal-title {
    max-width: 312px;
    font-size: 23px;
    line-height: 24px;
    font-weight: 700;
}

.package-update-modal-description {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
}

.close-btn {
    border: 1px solid #CAD5E2;
    color: #595D70;
    font-weight:600;
    font-size: 14px;
}
</style>